import _createForOfIteratorHelper from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/createForOfIteratorHelper.js";
import _regeneratorRuntime from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import Hamburger from '@/components/Hamburger';
import Screenfull from '@/components/Screenfull';
import SizeSelect from '@/components/SizeSelect';
import Search from '@/components/HeaderSearch';
import Avatar from '@/assets/images/avatar.png';
import { filterAsyncRouter } from "@/store/modules/permission";
import router from "@/router/routers";
import Layout from "@/layout/index.vue";
import store from "@/store";
export default {
  components: {
    Breadcrumb: Breadcrumb,
    Hamburger: Hamburger,
    Screenfull: Screenfull,
    SizeSelect: SizeSelect,
    Search: Search
  },
  data: function data() {
    return {
      Avatar: Avatar,
      dialogVisible: false,
      menuCategory: [],
      defaultActive: String(0)
    };
  },
  created: function created() {
    this.menuCategory = JSON.parse(localStorage.getItem("allMenus"));
    if (this.menuCategory && this.menuCategory.length > 0) {
      var to = JSON.parse(localStorage.getItem("to"));
      var find = this.findCategoryByPath(to.fullPath);
      if (find.index === -1) {
        find = this.findCategoryByPath(to.path);
      }
      this.defaultActive = String(find.index);
      this.handleTopMenuClick(find.category);
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['sidebar', 'device', 'user', 'baseApi'])), {}, {
    show: {
      get: function get() {
        return this.$store.state.settings.showSettings;
      },
      set: function set(val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'showSettings',
          value: val
        });
      }
    }
  }),
  methods: {
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    open: function open() {
      var _this = this;
      this.$confirm('确定注销并退出系统吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.logout();
      });
    },
    logout: function logout() {
      this.$store.dispatch('LogOut').then(function () {
        location.reload();
      });
    },
    /**
     * 动态路由加载，根据菜单分类的配置重新渲染路由信息
     * @param val
     * @returns {Promise<void>}
     */
    handleTopMenuClick: function () {
      var _handleTopMenuClick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(val) {
        var menus, home;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (val) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              menus = [];
              home = {
                path: '/',
                name: 'root',
                hidden: true,
                component: Layout,
                meta: {
                  title: '首页',
                  icon: 'index'
                },
                redirect: '/home',
                children: [{
                  path: 'home',
                  name: 'home',
                  component: function component(resolve) {
                    return require(['@/views/home'], resolve);
                  },
                  meta: {
                    title: '首页',
                    icon: 'yingxiao',
                    affix: false
                  }
                }]
              };
              if (val.menus.length > 0) {
                menus = filterAsyncRouter(val.menus);
                menus.push(_objectSpread(_objectSpread({}, home), {}, {
                  hidden: true
                }));
              } else {
                if (val.categoryId === '1') {
                  menus.push(_objectSpread(_objectSpread({}, home), {}, {
                    hidden: false
                  }));
                } else {
                  menus.push(_objectSpread(_objectSpread({}, home), {}, {
                    hidden: true
                  }));
                }
              }
              menus.push({
                path: '*',
                redirect: '/404',
                hidden: true
              });
              store.dispatch('GenerateRoutes', menus).then(function () {
                // 存储路由
                router.addRoutes(menus); // 动态添加可访问路由表
                // next({ ...to, replace: true })
              });
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function handleTopMenuClick(_x) {
        return _handleTopMenuClick.apply(this, arguments);
      }
      return handleTopMenuClick;
    }(),
    /**
     * 递归查找菜单路径，拼接父级路径和子级路径
     * @param {Array} menus 菜单数组
     * @param {String} path 当前要查找的路径
     * @param {String} parentPath 父菜单的路径，初始值为空字符串
     * @returns {Boolean} 找到返回 true，否则返回 false
     */
    findMenuByPath: function findMenuByPath(menus, path) {
      var parentPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      if (!menus && menus.length === 0) {
        return false;
      }
      var _iterator = _createForOfIteratorHelper(menus),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var menu = _step.value;
          // 拼接当前菜单的完整路径
          var fullPath = parentPath ? "".concat(parentPath, "/").concat(menu.path) : menu.path;

          // 检查是否完全匹配
          if (fullPath === path) {
            return true; // 找到匹配的菜单
          }

          // 如果有子菜单，递归查找
          if (menu.children && menu.children.length > 0) {
            var found = this.findMenuByPath(menu.children, path, fullPath);
            if (found) {
              return true; // 找到后提前返回
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return false; // 未找到
    },
    /**
     * 遍历所有分类，找到与路径匹配的分类
     * @param {String} path 完整的路径
     * @returns {Object} 返回找到的分类和下标
     */
    findCategoryByPath: function findCategoryByPath(path) {
      var _this2 = this;
      var foundCategory = null; //{ categoryId: '1', categoryName: '首页',menus:[]};
      var foundIndex = -1; //0;

      // 遍历分类
      this.menuCategory.some(function (category, index) {
        // 在每个分类的菜单中查找
        var found = _this2.findMenuByPath(category.menus, path);
        if (found) {
          foundCategory = category;
          foundIndex = index;
          return true; // 找到后提前退出循环
        }
        return false;
      });

      // 默认返回菜单首页
      return {
        category: foundCategory,
        index: foundIndex
      };
    }
  }
};